import React from 'react';
import { Circle, Rect, Arrow } from './style';
import { LineShape } from 'graphql/types';

interface LinkShapeProps {
  color?: string;
  type?: LineShape;
  rotation?: number;
  end?: boolean;
  start?: boolean;
}

export default function LinkShape({ type, color, start, end }: LinkShapeProps) {
  switch (type) {
    case LineShape.Square:
      return <Rect color={color} />;
    case LineShape.Circle:
      return <Circle color={color} />;
    case LineShape.Arrow:
      return <Arrow color={color} $start={start} $end={end} />;
    default:
      return null;
  }
}
